import constate from 'constate'
import { EntityId, TemporalEntityId } from 'entities-next/common'
import { QueryFunctionContext, QueryStatus, useQuery } from 'react-query'

import { Corporate, CORPORATE_CACHE_STORE_ID, getApiCorporateHandlers } from '../../../../../../entities-next/corporate'
import { newCorporate } from '../../../../../../entities-next/corporate/corporate.helpers'

export type CorporateDetailsViewStore = {
  state: {
    corporateId: number
    corporate?: Corporate
    actionBarRef: React.MutableRefObject<any>
    status: QueryStatus
  }
}

function useCorporateDetailsViewInternalStore({
  corporateId,
  actionBarRef,
}: Pick<CorporateDetailsViewStore['state'], 'corporateId' | 'actionBarRef'>): CorporateDetailsViewStore {
  const corporateData = useCorporateEntity(corporateId)
  return {
    state: { actionBarRef, ...corporateData },
  }
}

function useCorporateEntity(corporateId: EntityId) {
  const { data: corporate, status } = useQuery([CORPORATE_CACHE_STORE_ID, corporateId], corporateQuery, {
    refetchOnWindowFocus: false,
  })

  return {
    corporateId,
    corporate,
    status,
  }
}

async function corporateQuery({ queryKey }: QueryFunctionContext<[string, EntityId]>): Promise<Corporate> {
  const [, corporateId] = queryKey
  const isNewCorporate = corporateId === TemporalEntityId.new
  const { apiGetCorporate } = getApiCorporateHandlers()
  return !isNewCorporate ? apiGetCorporate(corporateId) : newCorporate()
}

export const [CorporateDetailsViewProvider, useCorporateDetailsViewStore] = constate(
  useCorporateDetailsViewInternalStore
)
